import React from 'react'
import Checkbox from '../../../../shared/ui/controls/Checkbox/Checkbox'
import { ActiveFilterItem } from '../model/buildActiveFilterItems'

interface ExportFilterChecklistProps {
  items: ActiveFilterItem[]
  checked: Set<string>
  onToggle: (key: string) => void
}

export const ExportFilterChecklist: React.FC<ExportFilterChecklistProps> = ({ items, checked, onToggle }) => (
  <div className="flex-1 min-w-0">
    <p className="text-sm font-semibold text-gray-600 mb-3">
      Filter
      <span className="text-xs font-normal text-gray-400 ml-1">(im Export anzeigen)</span>
    </p>
    {items.length === 0 ? (
      <p className="text-sm text-gray-400 italic">Keine aktiven Filter</p>
    ) : (
      <div className="flex flex-col gap-2">
        {items.map((item) => (
          <div
            key={item.key}
            className="flex items-start gap-2 cursor-pointer"
            onClick={() => onToggle(item.key)}
          >
            <div className="mt-0.5 shrink-0">
              <Checkbox checked={checked.has(item.key)} />
            </div>
            <div className="min-w-0">
              <div className="text-xs text-gray-500">{item.label}</div>
              <div className="text-sm font-medium text-gray-800 truncate">{item.value}</div>
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
)
